import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useRoute } from 'vue-router'

import TheBasesYCondiciones from '@/components/bases-condiciones/TheBasesYCondiciones.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BasesYCondiciones',
  setup(__props) {

const route = useRoute()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(TheBasesYCondiciones, {
      name: _unref(route).params.sorteo
    }, null, 8, ["name"])
  ]))
}
}

})